import { ComponentType } from "../types";

type IconProps = {
    disabled?: boolean;
};

function getIconColour(disabled: boolean, defaultColour: string) {
    return disabled ? "#949494" : defaultColour;
}

const PickerIcon = ({ disabled = false }: IconProps) => {
    const iconColour = getIconColour(disabled, "#3B78BD");

    return (
        <svg className="library-component-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path fill={iconColour} d="M14 16h6v6h-6zM14 8h6v6h-6zM4 18h10v2H4zM4 10h10v2H4z" />
            <path fill={iconColour} d="M6 2v18H4V2z" />
        </svg>
    );
};

const ListIcon = ({ disabled = false }: IconProps) => {
    const iconColour = getIconColour(disabled, "#3B78BD");

    return (
        <svg className="library-component-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="4" cy="6" r="2" fill={iconColour} />
            <circle cx="4" cy="12" r="2" fill={iconColour} />
            <circle cx="4" cy="18" r="2" fill={iconColour} />
            <rect x="8" y="5" width="14" height="2" fill={iconColour} />
            <rect x="8" y="11" width="14" height="2" fill={iconColour} />
            <rect x="8" y="17" width="14" height="2" fill={iconColour} />
        </svg>
    );
};

const DiaryIcon = ({ disabled = false }: IconProps) => {
    const iconColour = getIconColour(disabled, "#3B78BD");

    return (
        <svg className="library-component-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.32 22H5.19003C4.73163 22 4.36003 21.6284 4.36003 21.17V19.68H3.68003C3.25408 19.6333 2.93154 19.2735 2.93154 18.845C2.93154 18.4165 3.25408 18.0567 3.68003 18.01H4.36003V17H3.68003C3.22002 16.9945 2.84999 16.62 2.85003 16.16C2.85003 15.7016 3.22163 15.33 3.68003 15.33H4.36003V14.33H3.68003C3.22002 14.3245 2.84999 13.95 2.85003 13.49C2.85003 13.0316 3.22163 12.66 3.68003 12.66H4.36003V11.54H3.68003C3.22163 11.54 2.85003 11.1684 2.85003 10.71C2.84999 10.25 3.22002 9.87548 3.68003 9.87H4.36003V8.87H3.68003C3.45279 8.87026 3.23538 8.77735 3.07852 8.61293C2.92166 8.44851 2.83907 8.22697 2.85003 8C2.84999 7.53996 3.22002 7.16548 3.68003 7.16H4.36003V6.16H3.68003C3.25408 6.11332 2.93154 5.7535 2.93154 5.325C2.93154 4.8965 3.25408 4.53668 3.68003 4.49H4.36003V2.83C4.36003 2.3716 4.73163 2 5.19003 2H20.32C20.7784 2 21.15 2.3716 21.15 2.83V21.17C21.15 21.6284 20.7784 22 20.32 22ZM6.00003 4.45H6.78003C7.10016 4.41491 7.41217 4.56595 7.58324 4.83881C7.75431 5.11168 7.75431 5.45832 7.58324 5.73119C7.41217 6.00405 7.10016 6.15509 6.78003 6.12H6.00003V7.12H6.78003C7.01421 7.11434 7.24034 7.20557 7.40503 7.37216C7.56972 7.53874 7.65836 7.7659 7.65003 8C7.64455 8.46001 7.27007 8.83003 6.81003 8.83H6.00003V9.83H6.78003C7.24169 9.8354 7.61463 10.2083 7.62003 10.67C7.61455 11.13 7.24007 11.5 6.78003 11.5H6.00003V12.55H6.78003C7.24007 12.55 7.61455 12.92 7.62003 13.38C7.61463 13.8417 7.24169 14.2146 6.78003 14.22H6.00003V15.22H6.78003C7.24007 15.22 7.61455 15.59 7.62003 16.05C7.61463 16.5117 7.24169 16.8846 6.78003 16.89H6.00003V17.89H6.78003C7.10016 17.8549 7.41217 18.0059 7.58324 18.2788C7.75431 18.5517 7.75431 18.8983 7.58324 19.1712C7.41217 19.444 7.10016 19.5951 6.78003 19.56H6.00003V20.21H8.40003V3.67H6.00003V4.45ZM19.45 3.67H10.1V20.33H19.48L19.45 3.67ZM12.05 5.42H17.53C17.9884 5.42 18.36 5.7916 18.36 6.25V10.25C18.36 10.7084 17.9884 11.08 17.53 11.08H12.05C11.8299 11.08 11.6188 10.9926 11.4631 10.8369C11.3075 10.6812 11.22 10.4701 11.22 10.25V6.25C11.22 6.02987 11.3075 5.81876 11.4631 5.6631C11.6188 5.50745 11.8299 5.42 12.05 5.42ZM12.89 9.42H16.69V7.08H12.89V9.42Z"
                fill={iconColour}
            />
        </svg>
    );
};

const CheckboxIcon = ({ disabled = false }: IconProps) => {
    const iconColour = getIconColour(disabled, "#3B78BD");

    return (
        <svg className="library-component-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M19 2H5C3.34315 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V5C22 3.34315 20.6569 2 19 2Z"
                fill={iconColour}
            />
            <path
                d="M17.291 6.29297L18.7052 7.70718L8.95189 17.4605L5.29291 13.8015L6.70712 12.3873L8.95101 14.6321L17.291 6.29297Z"
                fill="white"
            />
        </svg>
    );
};

const NumericIcon = ({ disabled = false }: IconProps) => {
    const iconColour = getIconColour(disabled, "#3B78BD");

    return (
        <svg className="library-component-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M18 3H6C4.34315 3 3 4.34315 3 6V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V6C21 4.34315 19.6569 3 18 3Z"
                fill="white"
                stroke={iconColour}
                strokeWidth="2"
            />
            <path
                d="M10.6034 11.1444H11.822C12.4022 11.1444 12.8322 11.0218 13.1118 10.7767C13.3914 10.5316 13.5312 10.2063 13.5312 9.8008C13.5312 9.40865 13.3914 9.10339 13.1118 8.88503C12.8375 8.66667 12.4576 8.55749 11.9723 8.55749C11.5345 8.55749 11.1678 8.65998 10.8724 8.86497C10.577 9.06551 10.4293 9.32843 10.4293 9.65374H8.14243C8.14243 9.14572 8.30333 8.69118 8.62512 8.29011C8.95219 7.88458 9.40587 7.56818 9.98615 7.34091C10.5717 7.11364 11.2153 7 11.9169 7C13.1355 7 14.0903 7.24733 14.7814 7.74198C15.4725 8.23217 15.818 8.90954 15.818 9.77406C15.818 10.2197 15.6571 10.6297 15.3353 11.004C15.0135 11.3783 14.5915 11.6658 14.0692 11.8663C14.7181 12.0624 15.2008 12.3565 15.5173 12.7487C15.8391 13.1408 16 13.6043 16 14.139C16 15.0036 15.6255 15.6965 14.8764 16.2179C14.1325 16.7393 13.1461 17 11.9169 17C10.7669 17 9.82526 16.7438 9.09199 16.2313C8.364 15.7188 8 15.0414 8 14.1992H10.2868C10.2868 14.5646 10.4477 14.8632 10.7695 15.0949C11.0966 15.3266 11.4975 15.4425 11.9723 15.4425C12.5157 15.4425 12.9403 15.3222 13.2463 15.0816C13.5575 14.8365 13.7132 14.5134 13.7132 14.1123C13.7132 13.1408 13.0801 12.6551 11.814 12.6551H10.6034V11.1444Z"
                fill={iconColour}
            />
        </svg>
    );
};

const TextboxIcon = ({ disabled = false }: IconProps) => {
    const iconColour = getIconColour(disabled, "#3B78BD");

    return (
        <svg className="library-component-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M18 3H6C4.34315 3 3 4.34315 3 6V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V6C21 4.34315 19.6569 3 18 3Z"
                fill="white"
                stroke={iconColour}
                strokeWidth="2"
            />
            <path
                d="M14.3898 17V16.6243C13.8479 16.6243 13.4913 16.5352 13.3201 16.3569C13.1489 16.1787 13.0632 15.8174 13.0632 15.2731V8.12249C13.7265 8.14175 14.2251 8.25495 14.5589 8.46208C15.1528 8.8378 15.5127 8.91956 15.6384 9.9841V10.6225H16.022L16.009 7H7.99097L7.97797 10.6225H8.36164C8.44401 9.56757 8.80383 8.84744 9.44112 8.46208C9.78794 8.25495 10.2865 8.14175 10.9368 8.12249V15.2731C10.9368 15.8126 10.8512 16.1727 10.6799 16.3533C10.5087 16.534 10.1629 16.6243 9.64271 16.6243V17H14.3898Z"
                fill={iconColour}
            />
        </svg>
    );
};

const PanelIcon = ({ disabled = false }: IconProps) => {
    const iconColour = getIconColour(disabled, "#3B78BD");
    const iconSecondaryColour = getIconColour(disabled, "#2078C3");

    return (
        <svg className="library-component-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M18 3H6C4.34315 3 3 4.34315 3 6V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V6C21 4.34315 19.6569 3 18 3Z"
                fill="white"
                stroke={iconColour}
                strokeWidth="2"
            />
            <path d="M20 4H4V7H20V4Z" fill={iconSecondaryColour} />
        </svg>
    );
};

const TabIcon = ({ disabled = false }: IconProps) => {
    const iconColour = getIconColour(disabled, "#3B78BD");
    const iconSecondaryColour = getIconColour(disabled, "#2078C3");

    return (
        <svg className="library-component-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M18 3H6C4.34315 3 3 4.34315 3 6V18C3 19.6569 4.34315 21 6 21H18C19.6569 21 21 19.6569 21 18V6C21 4.34315 19.6569 3 18 3Z"
                fill="white"
                stroke={iconColour}
                strokeWidth="2"
            />
            <path d="M20 9H8V11H20V9Z" fill={iconSecondaryColour} />
            <path d="M10 4H8V9H10V4Z" fill={iconSecondaryColour} />
            <path d="M16 4H14V9H16V4Z" fill={iconSecondaryColour} />
        </svg>
    );
};

const TabPageIcon = ({ disabled = false }: IconProps) => {
    const iconColour = getIconColour(disabled, "#3B78BD");

    return (
        <svg className="library-component-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10,4V9h9a1,1,0,0,1,1,1v9a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V5A1,1,0,0,1,5,4h5m2-2H5A3,3,0,0,0,2,5V19a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V10a3,3,0,0,0-3-3H12V2Z"
                fill={iconColour}
            />
        </svg>
    );
};

const TextIcon = ({ disabled = false }: IconProps) => {
    const iconColour = getIconColour(disabled, "#3B78BD");

    return (
        <svg className="library-component-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16.7534 21.4507V20.7781C15.6756 20.7781 14.9663 20.6186 14.6257 20.2995C14.2851 19.9805 14.1148 19.3337 14.1148 18.3593V5.55872C15.4341 5.59321 16.4258 5.79585 17.0897 6.16664C18.2711 6.83924 18.9868 6.98559 19.2369 8.89127V10.0341H20L19.9741 3.54932H4.02587L4 10.0341H4.76314C4.92697 8.14562 5.64268 6.85648 6.91027 6.16664C7.60011 5.79585 8.59175 5.59321 9.88521 5.55872V18.3593C9.88521 19.3251 9.7149 19.9697 9.37429 20.2931C9.03368 20.6164 8.346 20.7781 7.31124 20.7781V21.4507H16.7534Z"
                fill={iconColour}
            />
        </svg>
    );
};

const MacroIcon = ({ disabled = false }: IconProps) => {
    const iconColour = getIconColour(disabled, "#3B78BD");

    return (
        <svg className="library-component-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.993 13C19.6642 13.0596 17.5482 13.7462 15.6449 15.06C13.7416 16.3737 12.5266 17.782 12 19.2848V22C15.331 22 17.8522 21.177 19.5636 19.5311C21.275 17.8851 22.0848 15.7081 21.993 13Z"
                fill={iconColour}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.00701 13C4.33579 13.0596 6.45183 13.7462 8.35512 15.06C10.2584 16.3737 11.4734 17.782 12 19.2848V22C8.669 22 6.14781 21.177 4.43642 19.5311C2.72503 17.8851 1.91523 15.7081 2.00701 13Z"
                fill={iconColour}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 2L9.26094 5.19252L12.0215 2L15.0389 5.3334L18 2C18 3.57408 18 5.00193 18 6.28354C18 8.20597 16.5761 12 12.1729 12C7.76977 12 6 8.56163 6 6.28354C6 4.76482 6 3.33697 6 2Z"
                fill={iconColour}
            />
            <path d="M13 8H11V20H13V8Z" fill={iconColour} />
        </svg>
    );
};

type CalculatorIconProps = IconProps & {
    colour?: string;
};

export const CalculatorIcon = ({ colour = "#3B78BD", disabled = false }: CalculatorIconProps) => {
    const iconColour = getIconColour(disabled, colour);

    return (
        <svg className="library-component-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fill={iconColour}
                d="M17.7,20H6.29V4H17.7Zm0-18H6.3A2.17,2.17,0,0,0,4,4V20a2.17,2.17,0,0,0,2.3,2H17.7A2.17,2.17,0,0,0,20,20V4a2.17,2.17,0,0,0-2.3-2Z"
            />
            <circle cx="12" cy="11" r="1" fill={iconColour} />
            <circle cx="9" cy="11" r="1" fill={iconColour} />
            <circle cx="15" cy="11" r="1" fill={iconColour} />
            <circle cx="12" cy="14" r="1" fill={iconColour} />
            <circle cx="9" cy="14" r="1" fill={iconColour} />
            <circle cx="15" cy="14" r="1" fill={iconColour} />
            <circle cx="12" cy="17" r="1" fill={iconColour} />
            <circle cx="9" cy="17" r="1" fill={iconColour} />
            <circle cx="15" cy="17" r="1" fill={iconColour} />
            <rect x="9" y="16" width="3" height="2" fill={iconColour} />
            <rect x="8" y="6" width="8" height="3" fill={iconColour} />
        </svg>
    );
};

export const ImageIcon = ({ disabled = false }: IconProps) => {
    const iconColour = getIconColour(disabled, "#3B78BD");

    return (
        <svg className="library-component-icon" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
            <g>
                <path
                    fill={iconColour}
                    d="M368,224c26.5,0,48-21.5,48-48c0-26.5-21.5-48-48-48c-26.5,0-48,21.5-48,48C320,202.5,341.5,224,368,224z"
                />
                <path
                    fill={iconColour}
                    d="M452,64H60c-15.6,0-28,12.7-28,28.3v327.4c0,15.6,12.4,28.3,28,28.3h392c15.6,0,28-12.7,28-28.3V92.3   C480,76.7,467.6,64,452,64z M348.9,261.7c-3-3.5-7.6-6.2-12.8-6.2c-5.1,0-8.7,2.4-12.8,5.7l-18.7,15.8c-3.9,2.8-7,4.7-11.5,4.7   c-4.3,0-8.2-1.6-11-4.1c-1-0.9-2.8-2.6-4.3-4.1L224,215.3c-4-4.6-10-7.5-16.7-7.5c-6.7,0-12.9,3.3-16.8,7.8L64,368.2V107.7   c1-6.8,6.3-11.7,13.1-11.7h357.7c6.9,0,12.5,5.1,12.9,12l0.3,260.4L348.9,261.7z"
                />
            </g>
        </svg>
    );
};

export const QueryIcon = ({ disabled = false }: IconProps) => {
    const iconColour = getIconColour(disabled, "#3B78BD");

    return (
        <svg className="library-component-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.3206 20H3.19057C2.97044 20 2.75933 19.9126 2.60368 19.7569C2.44802 19.6012 2.36057 19.3901 2.36057 19.17V17.68H1.68057C1.47487 17.6575 1.28473 17.5598 1.1466 17.4057C1.00847 17.2516 0.932089 17.0519 0.932089 16.845C0.932089 16.6381 1.00847 16.4384 1.1466 16.2843C1.28473 16.1302 1.47487 16.0325 1.68057 16.01H2.36057V15H1.68057C1.45953 14.9974 1.24843 14.9077 1.09306 14.7505C0.937684 14.5932 0.850558 14.3811 0.850574 14.16C0.850574 13.9399 0.93802 13.7288 1.09368 13.5731C1.24933 13.4174 1.46044 13.33 1.68057 13.33H2.36057V12.33H1.68057C1.45953 12.3274 1.24843 12.2377 1.09306 12.0805C0.937684 11.9232 0.850558 11.7111 0.850574 11.49C0.850574 11.2699 0.93802 11.0588 1.09368 10.9031C1.24933 10.7474 1.46044 10.66 1.68057 10.66H2.36057V9.54H1.68057C1.46044 9.54 1.24933 9.45255 1.09368 9.2969C0.93802 9.14124 0.850574 8.93013 0.850574 8.71C0.850558 8.48894 0.937684 8.27678 1.09306 8.11954C1.24843 7.96229 1.45953 7.87263 1.68057 7.87H2.36057V6.87H1.68057C1.56813 6.87013 1.45683 6.84741 1.35343 6.80322C1.25003 6.75903 1.15669 6.69429 1.07907 6.61293C1.00145 6.53157 0.94117 6.43529 0.901892 6.32992C0.862614 6.22456 0.845155 6.11232 0.850574 6C0.850558 5.77894 0.937684 5.56678 1.09306 5.40954C1.24843 5.25229 1.45953 5.16263 1.68057 5.16H2.36057V4.16H1.68057C1.47487 4.13745 1.28473 4.03977 1.1466 3.88568C1.00847 3.73159 0.932089 3.53194 0.932089 3.325C0.932089 3.11806 1.00847 2.91841 1.1466 2.76432C1.28473 2.61023 1.47487 2.51254 1.68057 2.49H2.36057V0.83C2.36057 0.60987 2.44802 0.398757 2.60368 0.243101C2.75933 0.0874462 2.97044 0 3.19057 0H18.3206C18.5407 0 18.7518 0.0874462 18.9075 0.243101C19.0631 0.398757 19.1506 0.60987 19.1506 0.83V19.17C19.1506 19.3901 19.0631 19.6012 18.9075 19.7569C18.7518 19.9126 18.5407 20 18.3206 20ZM4.00057 2.45H4.78057C4.8979 2.43714 5.01662 2.44915 5.129 2.48525C5.24137 2.52135 5.34488 2.58073 5.43277 2.65951C5.52066 2.73829 5.59096 2.83472 5.63909 2.94249C5.68721 3.05026 5.71209 3.16697 5.71209 3.285C5.71209 3.40303 5.68721 3.51974 5.63909 3.62751C5.59096 3.73528 5.52066 3.83171 5.43277 3.91049C5.34488 3.98927 5.24137 4.04865 5.129 4.08475C5.01662 4.12085 4.8979 4.13286 4.78057 4.12H4.00057V5.12H4.78057C4.89644 5.1172 5.01165 5.13812 5.11913 5.18149C5.22662 5.22485 5.32409 5.28974 5.40558 5.37216C5.48706 5.45458 5.55083 5.55279 5.59296 5.66076C5.63509 5.76873 5.6547 5.88417 5.65057 6C5.64794 6.22104 5.55828 6.43214 5.40104 6.58752C5.24379 6.74289 5.03163 6.83002 4.81057 6.83H4.00057V7.83H4.78057C5.00255 7.8326 5.2147 7.92193 5.37167 8.0789C5.52864 8.23587 5.61798 8.44802 5.62057 8.67C5.61794 8.89104 5.52828 9.10214 5.37104 9.25752C5.21379 9.41289 5.00163 9.50002 4.78057 9.5H4.00057V10.55H4.78057C5.00163 10.55 5.21379 10.6371 5.37104 10.7925C5.52828 10.9479 5.61794 11.159 5.62057 11.38C5.61798 11.602 5.52864 11.8141 5.37167 11.9711C5.2147 12.1281 5.00255 12.2174 4.78057 12.22H4.00057V13.22H4.78057C5.00163 13.22 5.21379 13.3071 5.37104 13.4625C5.52828 13.6179 5.61794 13.829 5.62057 14.05C5.61798 14.272 5.52864 14.4841 5.37167 14.6411C5.2147 14.7981 5.00255 14.8874 4.78057 14.89H4.00057V15.89H4.78057C4.8979 15.8771 5.01662 15.8892 5.129 15.9253C5.24137 15.9614 5.34488 16.0207 5.43277 16.0995C5.52066 16.1783 5.59096 16.2747 5.63909 16.3825C5.68721 16.4903 5.71209 16.607 5.71209 16.725C5.71209 16.843 5.68721 16.9597 5.63909 17.0675C5.59096 17.1753 5.52066 17.2717 5.43277 17.3505C5.34488 17.4293 5.24137 17.4886 5.129 17.5247C5.01662 17.5608 4.8979 17.5729 4.78057 17.56H4.00057V18.21H6.40057V1.67H4.00057V2.45ZM17.4506 1.67H8.10057V18.33H17.4806L17.4506 1.67ZM10.0506 3.42H15.5306C15.7507 3.42 15.9618 3.50745 16.1175 3.6631C16.2731 3.81876 16.3606 4.02987 16.3606 4.25V8.25C16.3606 8.47013 16.2731 8.68124 16.1175 8.8369C15.9618 8.99255 15.7507 9.08 15.5306 9.08H10.0506C9.94158 9.08 9.83365 9.05853 9.73295 9.01682C9.63225 8.97511 9.54075 8.91397 9.46368 8.8369C9.3866 8.75983 9.32547 8.66833 9.28375 8.56763C9.24204 8.46693 9.22057 8.359 9.22057 8.25V4.25C9.22057 4.141 9.24204 4.03307 9.28375 3.93237C9.32547 3.83167 9.3866 3.74017 9.46368 3.6631C9.54075 3.58603 9.63225 3.52489 9.73295 3.48318C9.83365 3.44147 9.94158 3.42 10.0506 3.42ZM10.8906 7.42H14.6906V5.08H10.8906V7.42Z"
                fill={iconColour}
            />
        </svg>
    );
};

type ComponentIconProps = { type: ComponentType; disabled?: boolean };
export const ComponentIcon = ({ type, disabled = false }: ComponentIconProps) => {
    switch (type) {
        case ComponentType.CODED:
            return <PickerIcon disabled={disabled} />;
        case ComponentType.CODED_PICKING_LIST:
        case ComponentType.PICKING_LIST:
            return <ListIcon disabled={disabled} />;
        case ComponentType.DIARY_ENTRY:
            return <DiaryIcon disabled={disabled} />;
        case ComponentType.UNCODED:
            return <CheckboxIcon disabled={disabled} />;
        case ComponentType.NUMERIC_VALUE:
            return <NumericIcon disabled={disabled} />;
        case ComponentType.FREE_TEXT:
            return <TextboxIcon disabled={disabled} />;
        case ComponentType.PANEL:
            return <PanelIcon disabled={disabled} />;
        case ComponentType.TAB_CONTAINER:
            return <TabIcon disabled={disabled} />;
        case ComponentType.TAB_PAGE:
            return <TabPageIcon disabled={disabled} />;
        case ComponentType.BRANDING:
            return <ImageIcon disabled={disabled} />;
        case ComponentType.CLINICAL_CONTENT:
            return <TextIcon disabled={disabled} />;
        case ComponentType.SAVED_CONTENT:
            return <MacroIcon disabled={disabled} />;
        case ComponentType.CALCULATOR:
            return <CalculatorIcon disabled={disabled} />;
        default:
            return null;
    }
};
